import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Para qué edad sirve el pack?',
  a: 'El pack está diseñado para niños de 3 a 10 años. Cada tomo tiene niveles de dificultad progresiva (fácil, medio, difícil y experto) para que el material se adapte a la edad y capacidad de tu hijo/a. Los tomos de Arte y Laberintos funcionan desde los 3 años. Los de Lógica y Lectoescritura desde los 5-6 años.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de tu compra recibís un email con el link de descarga. En menos de 5 minutos tenés los 6 tomos, los 6 bonos y (si elegiste el combo premium) el Tablero de Control Familiar listos para descargar e imprimir en tu casa.'
}, {
  q: '¿Necesito una impresora especial?',
  a: 'No. Cualquier impresora hogareña en blanco y negro funciona perfectamente. El pack está diseñado en A4 vertical para impresión doméstica. Si no tenés impresora podés llevarlo a una copistería.'
}, {
  q: '¿Qué lo diferencia de buscar actividades en Pinterest?',
  a: 'Pinterest te da actividades sueltas que tenés que buscar, evaluar, imprimir y organizar vos. El pack es un sistema completo con 240 páginas organizadas por nivel, tipo y objetivo. Más 120 páginas de bonos para que nunca tengas que improvsar nada. No buscás. Abrís y usás.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total sin preguntas. Si no es lo que esperabas, escribís a impulsolab.digital@gmail.com y te devolvemos el 100% del dinero. Sin formularios ni explicaciones.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-16 px-4 bg-zinc-950" data-id="element-190">
      <div className="max-w-3xl mx-auto" data-id="element-191">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-white" data-id="element-192">
          ❓ Lo que más nos preguntan
        </h2>

        <div className="space-y-4" data-id="element-193">
          {faqs.map((faq, i) => <div key={i} className={`border border-zinc-800 rounded-2xl overflow-hidden transition-colors ${open === i ? 'bg-zinc-900/80' : 'bg-zinc-900/30 hover:bg-zinc-900/50'}`} data-id="element-194">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center" onClick={() => setOpen(open === i ? null : i)} data-id="element-195">
                <span className="font-bold text-lg text-zinc-200" data-id="element-196">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-cyan-400 transition-transform ${open === i ? 'rotate-180' : ''}`} data-id="element-197" />
              </button>

              {open === i && <div className="px-6 pb-6 text-zinc-400 leading-relaxed" data-id="element-198">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}